ObjectUtils.define('UIFormController', {

  enableDebug: 0,

  getParams: function getParams(form) {
    form = DOM.findById(form);
    var params = {};

    ArrayUtils.each(["textarea", "input", "select", '.UICheckbox'], function(key, tagName) {
      var inputs = form.find(tagName);
      ArrayUtils.each(inputs, function(key, input) {
        input = DOM.findById(input);
        var inputName = DOM.getAttribute(input, 'name');

        if (!inputName) {
          return true;
        }

        var type = DOM.getAttribute(input, 'type');
        if (
          type === 'button'
          || type === 'submit'
          || (type === "radio" && !input.prop('checked'))
        ) {
          return true;
        }

        var inputValue;
        if (DOM.isCheckbox(input)) {
          inputValue = DOM.isCheckboxSelected(input) ? "on" : "off";
        } else {
          inputValue = input.val();
          // Multi-select
          if (ObjectUtils.isArray(inputValue)) {
            inputValue = ObjectUtils.toJS(inputValue);
          }
        }

        params[inputName] = inputValue;
      });
    });
    return params;
  },

  submitForControl: function submitForControl(control) {
    var form = DOM.findParentByTag(control, 'form');
    return UIFormController.submit(form, control);
  },

  submit: function submit(form, clickedElem, lparams) {
    lparams = lparams || {};

    var shouldForceSubmit = lparams.force;
    delete lparams.force;

    form = DOM.findById(form);

    // Do this very first to handle double clicks
    if (!shouldForceSubmit && DOM.hasClass(form, 'isLoading')) {
      this.enableDebug && Logger.log(this, 'Form is already submitted. Ignoring duplicate submit.');
      return EventDelegater.STOP;
    }
    this._setLoading(form, true, clickedElem);

    if (!DOM.maybeFindInput(form, '__cs')) {
      var clientState = Runtime.getClientStateAsString();
      var hiddenInput = DOM.fromContent("<input type='hidden' name='__cs' value='"+clientState+"' />");
      DOM.append(form, hiddenInput);
    }

    var params = this.getParams(form);
    this.enableDebug && Logger.log(this, 'Submitting form', params);

    if (UICaptchaController.maybeHandleFormSubmit(form, params)) {
      this.enableDebug && Logger.log(this, 'Form requires captcha');
      this._setLoading(form, false, clickedElem, {
        needsCaptcha: true,
      });
      return EventDelegater.STOP;
    }

    var clickedElemTarget = null;
    if (clickedElem) {
      if (DOM.isSubmitButton(clickedElem) || DOM.hasClass(clickedElem, 'UIButton')) {
        var buttonName = DOM.getAttribute(clickedElem, 'name');
        var buttonValue = DOM.getAttribute(clickedElem, 'value');
        if (buttonName && buttonValue) {
          params[buttonName] = buttonValue;
        }
        var buttonTitleContainer = DOM.maybeFindByClass(clickedElem, 'buttonTitleContainer');
        if (buttonTitleContainer) {
          clickedElemTarget = DOM.getAttribute(buttonTitleContainer, 'target');
        }
      }
    }

    var action = DOM.getAttribute(form, 'action') || '/decode';

    var submitUrl = Url.parse(action);
    submitUrl.addQueryParams(params);

    var formTarget = DOM.getAttribute(form, 'target');
    if (formTarget === '_new' || clickedElemTarget === '_new') {
      this._setLoading(form, false, clickedElem, {
        target: formTarget,
        clickedElemTarget: clickedElemTarget,
      });
      Page.openWindow(submitUrl.toString());
      return EventDelegater.STOP;
    }

    var displayUrl = Url.parse(action);
    // Filter out keys like __authToken
    var displayParams = {};
    ArrayUtils.each(params, function(key, value) {
      if (StringUtils.startsWith(key, '__')) {
        return true;
      }
      displayParams[key] = value;
    });
    displayUrl.addQueryParams(displayParams);
    displayUrl = displayUrl.toString();

    if (formTarget === 'asyncParent') {
      var ret = UIController.maybeReloadAsyncParentWithUrl(form, displayUrl);
      if (ret == EventDelegater.STOP) {
        this._setLoading(form, false, clickedElem, {
          target: formTarget,
        });
        return ret;
      }

      formTarget = null;
    }

    var notificationName = DOM.getAttribute(form, 'notify');
    if (notificationName) {
      this._setLoading(form, false, clickedElem, {
        notify: notificationName,
      });
      NotificationManager.trigger(notificationName, {
        'href': displayUrl
      });
      return EventDelegater.STOP;
    }

    if (!this._shouldSubmitAsync(form)) {
      this.enableDebug && Logger.log(this, 'Submitting form synchronously', form);
      this._setLoading(form, false, clickedElem, {
        submitAsync: false,
      });

      form.trigger('submit');

      return EventDelegater.STOP;
    }

    var request = AsyncRequest.create_DEPRECATED(submitUrl);

    if (clickedElem && !DOM.isCheckbox(clickedElem)) {
      request.loadingElement = clickedElem;
    } else if (DOM.getAttribute(form, 'loadingMode')) {
      // Useful to set checkbox loading states. See insights page forecast setting.
      request.loadingElement = form;
    }
    
    if (formTarget) {
      request.target = formTarget;

      var replaceInnerHtml = DOM.getAttribute(form, 'replaceInnerHtml') === 'true';
      if (replaceInnerHtml) {
        request.replaceInnerHtml = replaceInnerHtml;
      }
    }

    // Use 'POST' because form inputs can have large values, which if sent via GET
    // can result in "Request URI too long" errors.
    // https://buxfer.zendesk.com/agent/tickets/69843
    request.requestMethod = 'POST';
    request.evalScript = true;

    var progressBar = lparams.progressBar || DOM.maybeFindByClass(form, 'UIProgressBar');
    if (progressBar) {
      request.progressBar = progressBar;
    }

    request.onSuccess = FunctionUtils.bind(this, function(response, lp, params) {
      var target = form;
      // Handle async redirects (e.g.: print transactions)
      if (lp.target && !response.redirectUrl) {
        var targetId = DOM.getAttribute(response.elem, 'id');
        if (targetId) {
          target = DOM.findById(targetId);
        }
      }
      EventDelegater.delegateViaController('formDidSubmit', target, response);

      this._setLoading(form, false, clickedElem, {
        finishedSubmit: true,
      });

      if (lparams.callback) {
        return lparams.callback(response, lp, params);
      }

      return EventDelegater.FORWARD;
    });
    request.onError = FunctionUtils.bind(this, function(response, params) {
      this._setLoading(form, false, clickedElem, {
        error: response,
      });

      if (lparams.onError) {
        return lparams.onError(response, params);
      }

      return EventDelegater.FORWARD;
    });

    // Do this just before sending the request, which can hide overlay causing DOM elements to be missing.
    EventDelegater.delegateViaController('formWillSubmit', form, params);

    request.send();

    return EventDelegater.STOP;
  },

  onSubmitClick: function onSubmitClick(el) {
    var form = DOM.findParentByTag(el, 'form');
    return UIFormController.submit(form, el);
  },

  _shouldSubmitAsync: function _shouldSubmitAsync(form) {
    var enableAsync = DOM.getAttribute(form, 'enableAsync');
    if (enableAsync === 'false') {
      return false;
    }

    if (enableAsync === 'true') {
      return true;
    }

    if (!Runtime.areLinksAsync) {
      return false;
    }
    
    var action = DOM.getAttribute(form, 'action');

    Assert.TRUTHY(action, '[UIFormController] Expected non-empty action');
    
    return action.substr(0, 1) === '/';
  },

  _setLoading: function _setLoading(form, isLoading, clickedElem, options) {
    options = options || {};

    this.enableDebug && Logger.log(this, 'Setting form loading', isLoading, ObjectUtils.extend({
      clickedElem: {
        name: DOM.getAttribute(clickedElem, 'name'),
        elem: clickedElem,
      },
    }, options));

    DOM.addClassIf(form, 'isLoading', isLoading);

    if (!clickedElem || !DOM.hasClass(clickedElem, 'UIControl')) {
      clickedElem = DOM.maybeFindBySelector(form, '.UIButton[type=submit]');
    }

    clickedElem && DOM.setLoading(clickedElem, isLoading);
  },
});
